import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { useTranslation } from 'react-i18next';
import { useQueryParams, NumberParam, StringParam } from 'use-query-params';

import { HeroImageBackground } from 'components/organisms';
import { FilterSelect } from 'components/molecules';
import { BudgetService } from 'services/BudgetService';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    height: '100%',
    position: 'relative',
    overflow: 'hidden',
  },
  image: {
    height: 373,
    objectFit: 'cover',
  },
  textWhite: {
    color: 'white',
  },
  title: {
    fontWeight: 'bold',
    fontFamily: 'Roboto',
  },
  section: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    paddingTop: 0,
    paddingBottom: 0,
  },
  fakeSpace: {
    [theme.breakpoints.up('md')]: {
      width: 'calc(100% + 50px)',
    },
    [theme.breakpoints.up('lg')]: {
      marginLeft: theme.spacing(10),
    },
  },
}));

const Hero = (props) => {
  const { years, pbaPeriods, monitoringPeriods, className, onFilterChange, ...rest } = props; // eslint-disable-line no-unused-vars
  const classes = useStyles();

  const { t } = useTranslation();

  const [params, setParams] = useQueryParams({
    years: NumberParam,
    pbaPeriods: NumberParam,
    monitoringPeriods: StringParam,
  });

  useEffect(() => {
    if (years?.length && !params.pbaPeriods && !params.monitoringPeriods) {
      onFilterChange && onFilterChange('years', (params.years ?? years[0].value), 'true');
      setParams({ years: params.years ?? years[0].value });
    } else if (pbaPeriods?.length && !params.years && !params.monitoringPeriods) {
      onFilterChange && onFilterChange('pbaPeriods', params.pbaPeriods, 'true');
      setParams({ pbaPeriods: params.pbaPeriods});
    } else if (monitoringPeriods?.length && !params.years && !params.pbaPeriods) {
      onFilterChange && onFilterChange('monitoringPeriods', params.monitoringPeriods, 'true');
      setParams({ monitoringPeriods: params.monitoringPeriods});
    }    
  }, [years, pbaPeriods, monitoringPeriods]);

  const handleFilterChange = (name) => (event) => {
    onFilterChange && onFilterChange(name, event);

    setParams({ [name]: event.target.value }, 'replace');
  };

  return (
    <HeroImageBackground
      backgroundImg='assets/images/budget-cover.jpg'
      backgroundIcon='Budget/Budget'
      height={210}
      mobileHeight={200}
    >
      <Grid container spacing={0}>
        <Grid item md={4} xs={12}>
          <FilterSelect
            placeholder={t('BUDGET.ANNUAL_BUDGET')}
            icon='Budget/Buxheti Vjetor'
            startText={`${t('BUDGET.ANNUAL_BUDGET')}: `}
            items={years}
            value={params.years || ''}
            onChange={handleFilterChange('years')}
          />
        </Grid>
        <Grid item md={4} xs={12}>
          <FilterSelect
            placeholder={t('BUDGET.MEDIUM_TERM_BUDGET_PROGRAM')}
            icon='Budget/Programi Buxhetor Afatmesëm (PBA)'
            startText='PBA: '
            items={pbaPeriods}
            value={params.pbaPeriods || ''}
            onChange={handleFilterChange('pbaPeriods')}
          />
        </Grid>
        <Grid item md={4} xs={12}>
          <FilterSelect
            className={classes.fakeSpace}
            placeholder={t('BUDGET.BUDGET_MONITORING')}
            icon='Budget/Monitorimi i Buxhetit'
            startText={`${t('BUDGET.BUDGET_MONITORING')}: `}
            items={monitoringPeriods}
            value={params.monitoringPeriods || ''}
            onChange={handleFilterChange('monitoringPeriods')}
          />
        </Grid>
      </Grid>
    </HeroImageBackground>
  );
};

Hero.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,

  /**
   * fires when one of the filters changes
   */
  onFilterChange: PropTypes.func,
};

export default Hero;
